module.exports = __webpack_public_path__ + "img/article.2d0a9088.png";